import { FC } from "react";
import {HiveStateItem, HiveStatesWrapper} from "features/hives/ui/hivesTable/styles.ts";

type Props = {
    states: string[];
};

export const HiveStatesCell: FC<Props> = ({ states = [] }) => {
    if (!states.length) return null;

    const visible = states.slice(0, 2);
    const hiddenCount = states.length - visible.length;

    return (
        <HiveStatesWrapper>
            {visible.map((state, idx) => (
                <HiveStateItem key={idx}>{state}</HiveStateItem>
            ))}

            {hiddenCount > 0 && (
                <HiveStateItem>+{hiddenCount}</HiveStateItem>
            )}
        </HiveStatesWrapper>
    );
};
